// Single question template and logic

<template>
  <div class="vff-animate q-form" v-bind:class="mainClasses" ref="qanimate">
    <div class="q-inner">
      <div v-bind:class="{'f-section-wrap': question.type === QuestionType.SectionBreak}">
        <div v-bind:class="{'fh2 f-section-wrap': question.type !== QuestionType.SectionBreak}"><!--fh2-->
          <span class="f-tagline" v-if="question.bar">
            <div style ="position: relative;text-align: center;color: black;" class="container">
              <img src="../assets/images/emptybar.png" >
              <span style="position: absolute;right: 3%;bottom: 51%;" class="rightV">{{ pointsTotal }}</span>
            </div>
          </span>
          <span class="f-tagline" v-if="question.bar1">
            <div style ="position: relative;text-align: center;color: black;" class="container">
              <img src="../assets/images/Bar2uv.png" >
              <span style="position: absolute;right: 3%;bottom: 57%;" class="rightV">{{ pointsTotal }}</span>
            </div>
          </span>
          <span class="f-tagline" v-if="question.bar2">
            <div style ="position: relative;text-align: center;color: black;" class="container">
              <img src="../assets/images/Bar2_plushat.png" >
              <span style="position: absolute;right: 3%;bottom: 57%;" class="rightV">{{ pointsTotal }}</span>
            </div>
          </span>
          <span class="f-tagline" v-if="question.bar3">
            <div style ="position: relative;text-align: center;color: black;" class="container">
              <img src="../assets/images/Bar3_plussunglasses.png" >
              <span style="position: absolute;right: 3%;bottom: 57%;" class="rightV">{{ pointsTotal }}</span>
            </div>
          </span>
          <span class="f-tagline" v-if="question.bar4">
            <div style ="position: relative;text-align: center;color: black;" class="container">
              <img src="../assets/images/Bar4_plussunscreen.png" >
              <span style="position: absolute;right: 3%;bottom: 57%;" class="rightV">{{ pointsTotal }}</span>
            </div>
          </span>
          <span class="f-tagline" v-if="question.tagline && question.correct ==0">{{ question.tagline }}</span>
          <span class="f-tagline" v-else-if="question.tagline && question.correct ==1"><SpeechBubble :correct=false>{{ question.tagline }}</SpeechBubble></span>
          <span class="f-tagline" v-else-if="question.tagline && question.correct ==2"><SpeechBubble :correct=true>{{ question.tagline }}</SpeechBubble></span>

          <template v-if="question.title" >
            <span class="fh2" v-if="question.type === QuestionType.SectionBreak">{{ question.title }}</span>
     
            <span class="f-text" v-else>
             <!--  {{ question.title }}&nbsp;
              Required questions are marked by an asterisk (*) -->
              <span class="f-required" v-if="question.required" v-bind:aria-label="language.ariaRequired" role="note"><span aria-hidden="true">*</span></span>
              <span v-if="question.inline" class="f-answer">
                <component
                  ref="questionComponent"
                  v-bind:is="question.type"
                  v-bind:question="question"
                  v-bind:language="language"
                  v-model="dataValue"
                  v-bind:active="active"
                  v-bind:disabled="disabled"
                  v-on:next="onEnter"
                />
              </span>
            </span>
          </template>

          <span class="f-sub" v-if="showHelperText">
            <span v-if="question.subtitle && question.correct ==0">{{ question.subtitle }}</span>
            <span v-else-if="question.subtitle && question.correct ==1"><SpeechBubble :correct=false>{{ question.subtitle }}</SpeechBubble></span>
          <span  v-else-if="question.subtitle && question.correct ==2"><SpeechBubble :correct=true>{{ question.subtitle }}</SpeechBubble></span>

            <span class="f-help" v-if="question.type === QuestionType.LongText && !isMobile" v-html="question.helpText || language.formatString(language.longTextHelpText)"></span>

            <span class="f-help" v-if="question.type === QuestionType.MultipleChoice && question.multiple">{{ question.helpText || language.multipleChoiceHelpText }}</span>
            <span class="f-help" v-else-if="question.type === QuestionType.MultipleChoice">{{ question.helpText }}</span>
          </span>

          <div v-if="!question.inline" class="f-answer f-full-width">
            <div class="container">
              <div class="first-half">

              <!--   <span v-if="question.hero"><img class="fh2" style="float: left;" src="../assets/images/sunhero.png" alt="Hero" ></span>
                <span v-if="question.scientist"><img class="fh2" style="float: left;" src="../assets/images/scientist.png" alt="Scientist" ></span>
                <span v-if="question.uvindex"><img class="fh2" style="float: left;" src="../assets/images/uvindex.png" alt="UV Index" > </span>
                <span v-if="question.granny"><img class="fh2" style="float: left;" src="../assets/images/granny.png" alt="Grany" > </span>
                <span v-if="question.glassdoc"><img class="fh2" style="float: left;" src="../assets/images/ofthalmiatros.png" alt="Glass Doctor" > </span>
                <span v-if="question.dermatologist"><img class="fh2" style="float: left;" src="../assets/images/sunscreen_doctor.png" alt="Dermatologist Doctor" > </span>
                <span v-if="question.sun1"><img class="fh2" style="float: left; width:46% " src="../assets/images/Sunmeasure1.png" alt="UV Index" > </span>
                <span v-if="question.sun2"><img class="fh2" style="float: left; width:46% " src="../assets/images/Sunmeasure2.png" alt="UV Index" > </span>
                <span v-if="question.sun3"><img class="fh2" style="float: left; width:46% " src="../assets/images/Sunmeasure3.png" alt="UV Index" > </span>
                <span v-if="question.sun4"><img class="fh2" style="float: left; width:46% " src="../assets/images/Sunmeasure4.png" alt="UV Index" > </span>
             
    <YouTubeVideo v-if="question.video"
      :videoId="vidid"
      :startAt="startAt"
      :endAt="endAt"
      :subtitles="subtitles"
      :onEndAction="handleVideoEnd"
    />
--><!--<iframe v-if="question.video1" width="560" height="315" src="https://www.youtube.com/embed/ZSJITdsTze0?si=SEK7lzEfL5JrJB82&amp;start=65&end=155" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>              
<iframe v-if="question.video1" width="560" height="315" src="https://www.youtube.com/embed/ZSJITdsTze0?si=SEK7lzEfL5JrJB82&amp;start=223&end=285" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>              
<VueYoutubeEmbed
                    :videoId="vidid"
      :startAt="vidstart"
      :endAt="vidend"
      :subtitles="subtitlesOptions"
      @onEnd="handleVideoEnd"
                  ></VueYoutubeEmbed>
-->

<!-- <span><VueYoutubeEmbed
                    :videoId="vidid"
                    :player-vars="playerVars"
                  ></VueYoutubeEmbed></span> -->
</div>
<div class="second-half">
                <!--   Content for the second half goes here -->
              
                <YouTubeVideo v-if="question.video"
      :videoId="vidid"
      :startAt="startAt"
      :endAt="endAt"
      :subtitles="subtitles"
      :onEndAction="handleVideoEnd"
    />
    <YouTubeVideo v-if="question.video1"
      :videoId="vidid1"
      :startAt="startAt1"
      :endAt="endAt1"
      :subtitles="subtitles"
      :onEndAction="handleVideoEnd"
    />   
    <YouTubeVideo v-if="question.video2"
      :videoId="vidid1"
      :startAt="startAt2"
      :endAt="endAt2"
      :subtitles="subtitles"
      :onEndAction="handleVideoEnd"
    />   
           <!--   <iframe v-if="question.video" width="440" height="250" src="https://www.youtube.com/embed/JX8rv_natkw?si=FqtRcg3kWgpHPC55&amp;start=23&end=74" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                 <span><SpeechBubble class="right" v-if="question.id =='id2'">{{question.tagline}}</SpeechBubble></span>
                <span v-if="question.uvmeterbar"><img class="fh2" style="float: left; width:46% " src="../assets/images/HowToUse.png" alt="UV Index" > </span>
                -->
              </div>
     
            <component
              ref="questionComponent"
              v-bind:is="question.type"
              v-bind:question="question"
              v-bind:language="language"
              v-model="dataValue"
              v-bind:active="active"
              v-bind:disabled="disabled"
              v-on:next="onEnter"
            />
          </div>
          </div>
        </div>
        <p v-if="question.description || question.descriptionLink.length !== 0" class="f-description">
          <span v-if="question.description">{{ question.description }}</span>
          <a
            v-for="(link, index) in question.descriptionLink" 
            class="f-link" 
            v-bind:key="'m' + index"
            v-bind:href="link.url"
            v-bind:target="link.target"
          >{{ link.text || link.url }}</a>
        </p>

      </div>
    
      <div class="vff-animate f-fade-in f-enter" v-if="showOkButton()">
        <div class="f-section-text" style="float: right;" v-if="showSpan">
          Πόση να είναι τώρα άραγε, η υπεριώδης ακτινοβολία;
        <img style="float: right; width: 18%" src="../../examples/questionnaire/assets/images/images/arrowt.png" alt="Next" ref="button" v-on:click.prevent="onEnter" v-bind:aria-label="language.ariaOk">
        </div>

        <img v-if ="!showSpanIme" style="float: right; width: 13%" src="../../examples/questionnaire/assets/images/images/arrowt.png" alt="Next" ref="button" v-on:click.prevent="onEnter" v-bind:aria-label="language.ariaOk">
        <img v-if ="question.sun" style="float: right; width: 10%" src="../../examples/questionnaire/assets/images/images/sunall.png" alt="Next" ref="button" v-on:click.prevent="onEnter" v-bind:aria-label="language.ariaOk">

        <!--<button 
          class="o-btn-action"
          type="button"
          ref="button"
          href="#"
          v-on:click.prevent="onEnter"
          v-bind:aria-label="language.ariaOk"
        >
          <span v-if="question.type === QuestionType.SectionBreak">{{ language.continue }}</span>
          <span v-else-if="showSkip()">{{ language.skip }}</span>
          <span v-else>{{ language.ok }}</span>
        </button>

        <a 
          class="f-enter-desc"
          href="#"
          v-if="question.type !== QuestionType.LongText || !isMobile"
          v-on:click.prevent="onEnter"
          v-html="language.formatString(language.pressEnter)">
        </a>-->
      </div>

      <div v-if="showInvalid()" class="f-invalid" role="alert" aria-live="assertive">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
  /*
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://github.com/ditdot-dev/vue-flow-form
    https://www.ditdot.hr/en
  */
  import YouTubeVideo from './YoutubePlayer.vue';
  import SpeechBubble from './SpeechBubble.vue';
  import CanvasComponent from './CanvasComponent.vue';
  import LanguageModel from '../models/LanguageModel'
  import QuestionModel, { QuestionType, LinkOption } from '../models/QuestionModel'
  import FlowFormDropdownType from './QuestionTypes/DropdownType.vue'
  import FlowFormEmailType from './QuestionTypes/EmailType.vue'
  import FlowFormLongTextType from './QuestionTypes/LongTextType.vue'
  import FlowFormMultipleChoiceType from './QuestionTypes/MultipleChoiceType.vue'
  import FlowFormMultiplePictureChoiceType from './QuestionTypes/MultiplePictureChoiceType.vue'
  import FlowFormNumberType from './QuestionTypes/NumberType.vue'
  import FlowFormPasswordType from './QuestionTypes/PasswordType.vue'
  import FlowFormPhoneType from './QuestionTypes/PhoneType.vue'
  import FlowFormSectionBreakType from './QuestionTypes/SectionBreakType.vue'
  import FlowFormTextType from './QuestionTypes/TextType.vue'
  import FlowFormUrlType from './QuestionTypes/UrlType.vue'
  import FlowFormDateType from './QuestionTypes/DateType.vue'
  import FlowFormFileType from './QuestionTypes/FileType.vue'
  import FlowFormMatrixType from './QuestionTypes/MatrixType.vue'
  import FlowFormOpinionScaleType from './QuestionTypes/OpinionScaleType.vue'
  import FlowFormIconRateType from './QuestionTypes/IconRateType.vue'
  import { IsMobile } from '../mixins/IsMobile'
  

  export default {
    name: 'FlowFormQuestion',

    components: {
      YouTubeVideo,
      SpeechBubble,
      CanvasComponent,
      FlowFormDateType,
      FlowFormDropdownType,
      FlowFormEmailType,
      FlowFormLongTextType,
      FlowFormMultipleChoiceType,
      FlowFormMultiplePictureChoiceType,
      FlowFormNumberType,
      FlowFormPasswordType,
      FlowFormPhoneType,
      FlowFormSectionBreakType,
      FlowFormTextType,
      FlowFormFileType,
      FlowFormUrlType,
      FlowFormMatrixType,
      FlowFormOpinionScaleType,
      FlowFormIconRateType,
    },

    props: {
      question: QuestionModel,
      language: LanguageModel,
      value: [String, Array, Boolean, Number, Object],
      active: {
        type: Boolean,
        default: false
      },
      reverse: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      autofocus: {
        type: Boolean,
        default: true
      },
      pointsTotal:0,
    },

    mixins: [
      IsMobile
    ],

    data() {
      return {
        QuestionType: QuestionType,
        dataValue: null,
        debounced: false,
        points:0,
        showSpan: false,
        showSpanIme: false,
        showSunIme:false,
        test: false,
        vidid1:"ZSJITdsTze0",
        // playerVars: {
        autoplay: 1,
        startAt: 23, // Start time in seconds
        endAt: 75, // End time in seconds
        cc_lang_pref: 'el', // Subtitles language (Greek)
      // },
        vidid:'JX8rv_natkw',
        startAt1:65,
        endAt1:155,
        startAt2:223,
        endAt2:285,
        hatcounter:0,
        subtitles: {
        language: 'el', // Greek subtitles
      },
        subtitlesOptions: {
        hl: 'el', // Language code for the subtitles (e.g., 'en' for English)
        cc_lang_pref: 'el', // Language preference for closed captions (optional)
        cc_load_policy: 1,  // Show closed captions by default (optional)
        // Add more subtitle options as needed
      },
      }
      
    },

    mounted() {
      this.autofocus && this.focusField()
      this.dataValue = this.question.answer
      this.$refs.qanimate.addEventListener('animationend', this.onAnimationEnd)
      if(this.question.id =='dx_28'){
        console.log("id_28");
        this.question.totalpointshere =this.pointsTotal;
      }
   
    },

    beforeUnmount() {
      this.$refs.qanimate.removeEventListener('animationend', this.onAnimationEnd)
    },
    watch: {
    // Watch for changes in the 'message' prop
    pointsTotal(newValue, oldValue) {
     // console.log('Value of message changed:', newValue);
     // this.points = parseInt(newValue);
    },
    /*question:{
      handler(newVal, oldVal) {
        this.test = true;
     //   this.$forceUpdate();
        console.log('Prop object changed:', this.test);
        if (newVal.id =='dx_4') {
          setTimeout(() => {
     //       this.showSpanFuncOn();
          }, 2000); // Show the span after 2 seconds (adjust as needed)
        }else{
          this.ChangeTest();
          console.log('not');
         // this.showSpanFuncOff();

        }
      },
      deep: true // Watch for changes deeply within the object
    }*/
  },
    methods: {
      /**
       * Autofocus the input box of the current question
       */
      focusField() {
        const el = this.$refs.questionComponent
        
        el && el.focus()
      },
      async TotalPoints(){
        var y = parseInt(await this.question.RetrievePoints());
        this.$emit('custom-event', y+this.pointsTotal);
      },
      handleVideoEnd() {
      // Do something when the video ends
     // console.log("called");
    },
      ChangeTest(){
        this.test=!this.test
      },
     /* showSpanFuncOn(){
        console.log("showSPan");
        this.$set(this,'showSpan', true);
      },
      showSpanFuncOff(){
        console.log("showSPanoff");
        this.$set(this,'showSpan', false);
      },*/
      onAnimationEnd() {
        this.autofocus && this.focusField()
      },

      shouldFocus() {
        const q = this.$refs.questionComponent

        return q && q.canReceiveFocus && !q.focused
      },

      returnFocus() {
        const q = this.$refs.questionComponent

        if (this.shouldFocus()) {
          this.focusField()
        }
      },

      /**
       * Emits "answer" event and calls "onEnter" method on Enter press
       */ 
      onEnter($event) {
        this.checkAnswer(this.emitAnswer)
      },

      onTab($event) {
        this.checkAnswer(this.emitAnswerTab)
      },

      checkAnswer(fn) {
        const q = this.$refs.questionComponent
        this.TotalPoints()

        if (q.isValid() && this.question.isMultipleChoiceType() && this.question.nextStepOnAnswer &&  !this.question.multiple) {
          this.$emit('disable', true)

          this.debounce(() => {
            fn(q)
            this.$emit('disable', false)
          }, 350)
        } else {
          fn(q)
        }
      },

      emitAnswer(q) {
        if (q) {
          if (!q.focused) {
            this.$emit('answer', q)
          }

          q.onEnter()
        }
      },

      emitAnswerTab(q) {
        if (q && this.question.type !== QuestionType.Date) {
          this.returnFocus()
          this.$emit('answer', q)
          
          q.onEnter()
        }
      },

      debounce(fn, delay) {
        let debounceTimer
        this.debounced = true
      
        return (() => {
          clearTimeout(debounceTimer)
          debounceTimer = setTimeout(fn, delay)
        })()
      },
      
      /**
       * Check if the "OK" button should be shown.
       */
      showOkButton() {
        const q = this.$refs.questionComponent
        if (this.question.id =='dx_4') {
          this.showSpanIme =true
          setTimeout(() => {
            this.showSpan= true;
          }, 2000); // Show the span after 2 seconds (adjust as needed)
        }else if (this.question.id =='dx_5' || this.question.id =='dx_7'|| this.question.id =='dx_14'|| this.question.id =='dx_21'  ){
          this.showSpanIme = true;

        } else{
          this.showSpanIme = false;
          this.showSpan= false;

        }
        if (this.question.type === QuestionType.SectionBreak) {
          return this.active
        }

        if (!this.question.required) {
          return true
        }

        if (this.question.allowOther && this.question.other) {
          return true
        }

        if (this.question.isMultipleChoiceType() && !this.question.multiple && this.question.nextStepOnAnswer) {
          return false
        }
      
        // If there is no question referenced, or dataValue is still set to its default (null).
        // This allows a ChoiceOption value of false, but will not allow you to use null as a value.
        if (!q || this.dataValue === null) {
          return false
        }
        
        return q.hasValue && q.isValid()
      },

      showSkip() {
        const q = this.$refs.questionComponent

        // We might not have a reference to the question component at first
        // but we know that if we don't, it's definitely empty
        return !this.question.required && (!q || !q.hasValue)
      },

      /**
       * Determins if the invalid message should be shown.
       */
      showInvalid() {
        const q = this.$refs.questionComponent

        if (!q || this.dataValue === null) {
          return false
        }

        return q.showInvalid()
      }
    },

    computed: {
      mainClasses: {
        cache: false,
        get() {
          const classes = {
            'q-is-active': this.active,
            'q-is-inactive': !this.active,
            'f-fade-in-down': this.reverse,
            'f-fade-in-up': !this.reverse,
            'f-focused': this.$refs.questionComponent && this.$refs.questionComponent.focused,
            'f-has-value': this.$refs.questionComponent && this.$refs.questionComponent.hasValue
          }

          classes['field-' + this.question.type.toLowerCase().substring(8, this.question.type.length - 4)] = true

          return classes
        }
      },

      showHelperText() {
        if (this.question.subtitle) {
          return true
        }

        if (this.question.type === QuestionType.LongText || this.question.type === QuestionType.MultipleChoice) {
          return this.question.helpTextShow
        }

        return false
      },

      errorMessage() {
        const q = this.$refs.questionComponent

        if (q && q.errorMessage) {
          return q.errorMessage
        }

        return this.language.invalidPrompt
      }
    }
  }
</script>
